import React from "react"
import {
  FaFacebookSquare,
  FaLinkedin,
  // FaDribbbleSquare,
  // FaBehanceSquare,
  FaTwitterSquare,
} from "react-icons/fa"

const data = [
  {
    id: 1,
    icon: <FaFacebookSquare className="social-icon"></FaFacebookSquare>,
    url: "https://www.facebook.com/matthewjluck",
  },
  {
    id: 2,
    icon: <FaLinkedin className="social-icon"></FaLinkedin>,
    url: "https://www.linkedin.com/in/mjluck",
  },
  {
    id: 3,
    icon: <FaTwitterSquare className="social-icon"></FaTwitterSquare>,
    url: "https://www.twitter.com/mattluckdev",
  },
]
const links = data.map(link => {
  return (
    <li key={link.id}>
      <a href={link.url} className="social-link">
        {link.icon}
      </a>
    </li>
  )
})

// {
//   id: 3,
//   icon: <FaDribbbleSquare className="social-icon"></FaDribbbleSquare>,
//   url: "https://www.twitter.com",
// },
// {
//   id: 4,
//   icon: <FaBehanceSquare className="social-icon"></FaBehanceSquare>,
//   url: "https://www.twitter.com",
// },
export default ({ styleClass }) => {
  return (
    <ul className={`social-links ${styleClass ? styleClass : ""}`}>{links}</ul>
  )
}
